// extracted by mini-css-extract-plugin
export default {"table-container":"CompaniesTable_table-container__X19CF"};